import firebase from 'firebase/app';

const keyBase64 = process.env.REACT_APP_VISITOR_ENCRYPTION_KEY;

export function loadVisitors(result) {
   let vis = {
      expected: [],
      checkedIn: [],
      checkedOut: [],
   };
   if (result.visitorNo !== 0) {
      Object.entries(result).map(([key, value]) => {
         if (key !== 'visitorNo') {
            if (value.checkout) {
               vis.checkedOut.push({ uid: key, ...value });
            } else if (value.checkin) {
               vis.checkedIn.push({ uid: key, ...value });
            } else {
               vis.expected.push({ uid: key, ...value });
            }
         }
      });
   }

   vis.expected.sort((a, b) => {
      return a.name.localeCompare(b.name);
   });
   vis.checkedIn.sort((a, b) => {
      return a.name.localeCompare(b.name);
   });
   vis.checkedOut.sort((a, b) => {
      return a.name.localeCompare(b.name);
   });
   return vis;
}

export async function checkInVisitor(form, dateRef, lid, locationName, action) {
   var email = firebase.functions().httpsCallable('sendgridVisitors-sendgridVisitors');
   const batch = firebase.firestore().batch();
   const visitor = firebase.firestore().doc(`/location/${lid}/visitors/${dateRef}`);

   let data = {
      [form.uid]: {
         [action]: firebase.firestore.FieldValue.serverTimestamp(),
      },
   };
   if (action === 'checkin' && form.checkout) {
      data[form.uid].checkout = firebase.firestore.FieldValue.delete();
      data[form.uid].previousCheckin = firebase.firestore.FieldValue.arrayUnion(
         form.checkin,
         form.checkout,
      );
   }
   batch.set(visitor, { ...data }, { merge: true });
   try {
      await batch.commit();
      let data = {
         checkedIn: false,
         host: true,
         visitorName: form.name,
         visitorEmail: form.uid,
         hostName: form.host.name,
         hostEmail: form.host.email,
         locationName,
         carReg: false,
         contactNumber: false,
      };
      if (action === 'checkout') {
         data.checkedIn = true;
      }
      try {
         await email(data);
      } catch (error) {
         console.warn(error, 'error sending email');
      }
      return { code: 200, message: 'success' };
   } catch (error) {
      console.warn(error, 'error');
      return { code: 400, message: 'error' };
   }
}

export async function loadContractorsIndex(lid) {
   const contractors = await firebase
      .firestore()
      .doc(`visitors/${lid}/indexes/contractors`)
      .get();
   let data = [];
   if (contractors.exists) {
      Promise.all(
         Object.entries(contractors.data()).map(async ([key, value]) => {
            data.push({
               uid: key,
               email: await decrypt(value.email),
               name: value.name,
            });
         }),
      );
   }
   return data;
}

export async function loadCoPeopleIndex(cid) {
   const coPeople = await firebase.firestore().doc(`company/${cid}/indexes/people`).get();
   let data = [];
   if (coPeople.exists) {
      Object.entries(coPeople.data()).map(([key, value]) => {
         data.push({
            uid: key,
            email: value.email,
            name: `${value.name.firstName} ${value.name.lastName}`,
         });
      });
   }
   return data;
}

export function cryptoConfig() {
   const key = crypto.getRandomValues(new Uint8Array(32));
   const keyBase64 = btoa(String.fromCharCode(...key));
}

// Utility: Convert Base64 to Uint8Array
function base64ToUint8Array(base64) {
   // Add padding if necessary and remove invalid characters
   base64 = base64.replace(/[^A-Za-z0-9+/=]/g, '');
   while (base64.length % 4 !== 0) {
      base64 += '=';
   }
   return Uint8Array.from(atob(base64), (c) => c.charCodeAt(0));
}

// Utility: Convert Uint8Array to Base64
function uint8ArrayToBase64(bytes) {
   return btoa(String.fromCharCode(...bytes));
}
// const keyBase64 = 'CursEW7Fh8cmOVefGyQDH0WBOEMXnXxXWU/uyP49iuM=';
// const keyBase64 = '8wEdKYC2Yh9KLMbpNDaePWjt6qVH8fmKSNJ8oCNWNOA=';

// Encrypt using AES-GCM
export async function encrypt(text) {
   const keyBytes = base64ToUint8Array(keyBase64);
   const key = await crypto.subtle.importKey(
      'raw',
      keyBytes,
      { name: 'AES-GCM' },
      false,
      ['encrypt'],
   );

   const iv = crypto.getRandomValues(new Uint8Array(12)); // 96-bit IV for AES-GCM
   const encoder = new TextEncoder();
   const data = encoder.encode(text);

   const encryptedBuffer = await crypto.subtle.encrypt(
      { name: 'AES-GCM', iv },
      key,
      data,
   );

   // Combine IV + ciphertext
   const combined = new Uint8Array(iv.length + encryptedBuffer.byteLength);
   combined.set(iv);
   combined.set(new Uint8Array(encryptedBuffer), iv.length);

   return uint8ArrayToBase64(combined);
}

// Decrypt using AES-GCM
export async function decrypt(encryptedBase64) {
   const combined = base64ToUint8Array(encryptedBase64);
   const iv = combined.slice(0, 12); // First 12 bytes = IV
   const ciphertext = combined.slice(12);

   const keyBytes = base64ToUint8Array(keyBase64);
   const key = await crypto.subtle.importKey(
      'raw',
      keyBytes,
      { name: 'AES-GCM' },
      false,
      ['decrypt'],
   );

   const decryptedBuffer = await crypto.subtle.decrypt(
      { name: 'AES-GCM', iv },
      key,
      ciphertext,
   );

   const decoder = new TextDecoder();
   return decoder.decode(decryptedBuffer);
}
